$(document).ready(function () {

    $('.js_viewOtherLocations').on('click', function (e) {
        e.preventDefault();

        $('div[data-active-div="map"]').fadeOut(function () {
            $('div[data-active-div="list"]').fadeIn();
        });
    });

    $('.js_showMapDetails').on('click', function (e) {
        e.preventDefault();

        if (map_loaded !== true) {
            loadGoogleMapsOnDemand();
        }

        $('.js_showMapDetails').fadeOut(function () {
            $('.js_showLocationDetails').fadeIn();
        });

        $('div[data-active-div="map"]').fadeIn();
    });

    $('.js_showLocationDetails').on('click', function (e) {
        e.preventDefault();

        $('.js_showLocationDetails').fadeOut(function () {
            $('.js_showMapDetails').fadeIn();
        });

        $('div[data-active-div="map"]').fadeOut(function () {
            $('div[data-active-div="details"]').fadeIn();
        });
    });
});